import React from 'react'

import Slider from '../../../components/Slider'
import Popover from '../../../containers/Popovers/components/Popover'
import styles from './SliderPopover.css'

const SliderPopover = props => {
  const {
    handleOnChange,
    handleOnOutsidePopoverClick,
    label,
    min,
    max,
    minValue,
    maxValue,
  } = props

  return (
    <Popover
      className={styles.sliderPopover}
      onOutsidePopoverClick={handleOnOutsidePopoverClick}
    >
      <h2 className={styles.sliderTitle}>{label}</h2>
      <div className={styles.slider}>
        <Slider
          min={min}
          max={max}
          minValue={minValue}
          maxValue={maxValue}
          handleOnChange={handleOnChange}
        />
      </div>
    </Popover>
  )
}

export default SliderPopover



// WEBPACK FOOTER //
// ./src/legacy/containers/Popovers/SliderPopover/SliderPopover.jsx